import { useContext, useEffect } from "react";
import GeneralContext from "../context/GeneralContext";
import { useNavigate } from "react-router-dom";

function SuperAdminConsole() {

    const { redirect } = useContext(GeneralContext);

    const navigate = useNavigate();

    useEffect(() => {
        const redirectFunction = async () => {
        const redirectResponse = await redirect('super_admin');
        if (!redirectResponse.success) {navigate('/')}
        }
        redirectFunction();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

  return (
    <div>SuperAdminConsole</div>
  )
}

export default SuperAdminConsole